import * as A from 'fp-ts/Array';
import * as O from 'fp-ts/Option';
import * as NEA from 'fp-ts/NonEmptyArray';
import { pipe } from 'fp-ts/lib/function';

export const makeWordList = (items: string[]) => {
  if (!A.isNonEmpty(items)) {
    return '';
  }

  if (A.size(items) === 1) {
    return NEA.head(items);
  }

  if (A.size(items) === 2) {
    return items.join(' and ');
  }

  return pipe(
    items,
    A.modifyAt(A.size(items) - 1, (item) => `and ${item}`),
    O.map((items) => items.join(', ')),
    O.getOrElse(() => ''),
  );
};
